import { inject, Injectable } from '@angular/core';
import { Http, QueryHandlerFor } from '@skylab-angular-shared/core';

import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface ProductGeneratingSymbolItem {
    symbol: string
}

export class ProductGeneratingSymbolQuery extends Query<string> {
    constructor(readonly name: string) {
        super();
    }
}

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(ProductGeneratingSymbolQuery)
export class ProductGeneratingSymbolQueryHandler implements QueryHandler<ProductGeneratingSymbolQuery, string | null> {
    #Url = TaggedUrl.join('products/generateSymbol?name=:name', [Tags.Api, Tags.NotHandle404]);
    #http =  inject(Http) as HttpService;

    async handleAsync(query: ProductGeneratingSymbolQuery): Promise<string | null> {
        const url = fillPlaceholders(this.#Url, { name: encodeURIComponent(query.name) });
        return await this.#http.get<ProductGeneratingSymbolItem>(url).then(result => result.data.symbol, () => null);
    }
}
